export default __webpack_public_path__ + "static/media/block-blue.a0c35223.svg";